import { render, staticRenderFns } from "./BuscarOT.vue?vue&type=template&id=3c2e9ff0&"
import script from "./BuscarOT.vue?vue&type=script&lang=js&"
export * from "./BuscarOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports